var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "square-image-element media square-image-element__compensation",
    },
    [
      _c(
        "div",
        { staticClass: "square-image-element__image" },
        [
          _vm.customPriceImage
            ? _c("ResponsiveImage", { attrs: { image: _vm.customPriceImage } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "media-body" }, [
        _c("div", { staticClass: "square-image-element__body" }, [
          _c(
            "button",
            {
              staticClass: "square-image-element__title-container",
              on: { click: _vm.setCustomPriceSelected },
            },
            [
              _c(
                "span",
                { staticClass: "square-image-element__button-container" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "donate-block__product-checkbox",
                      class: {
                        "donate-block__product-checkbox--active":
                          _vm.customPriceSelected,
                      },
                    },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.listCheckmarkIcon) },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("span", [
                _c("span", { staticClass: "square-image-element__title" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.customPriceText) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "custom-price-element" }, [
            _c("div", { staticClass: "custom-price-element__title" }, [
              _vm._v("Anna summa"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "imask",
                  rawName: "v-imask",
                  value: _vm.mask,
                  expression: "mask",
                },
              ],
              staticClass: "custom-price-element__input",
              attrs: { "aria-label": "Anna summa", inputmode: "numeric" },
              on: { input: _vm.setCustomPrice },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }